// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // backend: 'http://3.80.106.131/', // INVICTA BILLING UI: BUCKET
  // backend: 'http://65.2.126.19/',
  // backend: 'https://invictaapi.continualengine.com/',
  contactUs: 'https://api.prep.continualengine.com/',
  backend: 'https://testinvictaapi.continualengine.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
